export const frameFinish = (value) => (value || "unframed").split(".")[0]

export function wallArUri(src, { art, width, height, depth, frame }) {
  const params = new URLSearchParams({ img: art, w: width, h: height, d: depth, frame })
  return `${src}?${params}`
}

const SQUARE_TOLERANCE = 0.05

export function artworkOrientation(width, height) {
  if (Math.abs(width - height) / Math.max(width, height) <= SQUARE_TOLERANCE) return "square"

  return width > height ? "landscape" : "portrait"
}
